(function ($) {
	"use strict";

	// Define variables for selectors
	var $toggleMenuButton = $('.main-menu-actions'),
		$hamburgerIcon = $toggleMenuButton.find('.hamburger'),
		$sidemenuWrapper = $('.sidemenu-wrapper'),
		$body = $('body'),
		sidemenuVisibleClass = 'is-visible',
		noScrollClass = 'no-scroll',
		sidemenuHiddenRight = '-598px',
		sidemenuVisibleRight = '0px',
		$gallerySlider = $('.gallery-slider');

	var $header = $('#header'),
        scrolledClass = 'scrolled',
        scrollThreshold = 240;

    // Function to handle scroll event
    function handleScroll() {
        if ($('body').data('page') === 1) {
            if ($(window).scrollTop() > scrollThreshold) {
                $header.addClass(scrolledClass);
            } else {
                $header.removeClass(scrolledClass);
            }
        } else {
            $header.removeClass(scrolledClass); // Ensure class is removed if not on the specified page
        }
    }

    // Attach scroll event listener
    $(window).on('scroll', handleScroll);

    // Call the function on page load to set the initial state
    handleScroll();

	// Function to dynamically adjust sidemenu width
	function adjustSidemenuWidth() {
		var windowWidth = $(window).width(),
			sidemenuWidth = '598px'; // Default width

		if (windowWidth < 768) {
			sidemenuWidth = '400px';
		}
		if (windowWidth < 480) {
			sidemenuWidth = '100%';
		}

		sidemenuHiddenRight = '-' + sidemenuWidth;
		$sidemenuWrapper.css('width', sidemenuWidth);

		if (!$sidemenuWrapper.hasClass(sidemenuVisibleClass)) {
			$sidemenuWrapper.css('right', sidemenuHiddenRight);
		}
	}

	// Toggle sidemenu visibility and body scroll
	function toggleSidemenu() {
		var isVisible = !$sidemenuWrapper.hasClass(sidemenuVisibleClass);
		$sidemenuWrapper.animate({ right: isVisible ? sidemenuVisibleRight : sidemenuHiddenRight }, 100, function () {
			$sidemenuWrapper.toggleClass(sidemenuVisibleClass, isVisible);
			$hamburgerIcon.toggleClass('active', isVisible);
			$body.toggleClass(noScrollClass, isVisible);
		});
	}

	// Event Handlers
	function attachEventHandlers() {
		$toggleMenuButton.on('click', toggleSidemenu);

		$(document).on('click', function (event) {
			if (!$(event.target).closest($sidemenuWrapper.add($toggleMenuButton)).length && $sidemenuWrapper.hasClass(sidemenuVisibleClass)) {
				toggleSidemenu(); // Close the sidemenu if clicking outside
			}
		});

		$(window).on('resize', adjustSidemenuWidth).trigger('resize');


	}

	// Initialize Slick Slider
	function initSlickSlider() {
		$gallerySlider.slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			centerMode: false,
			variableWidth: true,
			autoplaySpeed: 2000,
			arrows: false,
		});
		$(".right-trigg").click(function (e) {
			$gallerySlider.slick("slickNext");
		});
		// Prev button actions
		$(".left-trigg").click(function (e) {
			$gallerySlider.slick("slickPrev");
		});
	}

	// Function to handle forms submission for "Duales Studium / Berufsmessen / Angebot Termine"
	function setupFormSubmission(formId, ajaxUrl) {
		$(formId).on("submit", function (e) {
			e.preventDefault();

			var formData = new FormData(this); // Directly use the form reference for FormData

			// formData values for debugging
			for (var pair of formData.entries()) {
				console.log(pair[0] + ' : ' + pair[1]); // key : value
			}

			// AJAX request
			$.ajax({
				url: ajaxUrl,
				type: 'POST',
				data: formData,
				processData: false, //
				contentType: false, //
				success: function (data) {
					// console.log('Submission was successful for form: ' + formId);
					// console.log(data);
				},
				error: function (data) {
					// console.log('An error occurred for form: ' + formId);
					// console.log(data);
				},
			});
		});
	}

	// Initialize
	function init() {
		attachEventHandlers();
		initSlickSlider();

		// forms submission for "Duales Studium / Berufsmessen / Angebot Termine"
		// setupFormSubmission('#dualesStudiumForm', 'url1');
		// setupFormSubmission('#berufsmessenForm', 'url2');
		// setupFormSubmission('#angebotTermineForm', 'url3');

	}

	init();

	document.addEventListener('DOMContentLoaded', function () {
		const filteringTriggerFloat = document.querySelector('.filtering-trigger-float');
		const iconFilterFloat = document.querySelector('.icon-filter-float');
		const textFilterTrigger = document.querySelector('.text-holder'); // use this for trigger filter modal

		// Check if all required elements are found
		if (!filteringTriggerFloat || !iconFilterFloat || !textFilterTrigger) {
			return;
		}

		function handleResize() {
			if (window.innerWidth < 800) {
				filteringTriggerFloat.classList.add('ismobile');
				filteringTriggerFloat.style.right = '-184px';
			} else {
				filteringTriggerFloat.classList.remove('ismobile');
				filteringTriggerFloat.classList.remove('show');
				filteringTriggerFloat.style.right = '0';
			}
		}

		function handleIconClick() {
			if (window.innerWidth < 800) {
				if (filteringTriggerFloat.classList.contains('show')) {
					filteringTriggerFloat.classList.remove('show');
					filteringTriggerFloat.style.right = '-184px';
				} else {
					filteringTriggerFloat.classList.add('show');
					filteringTriggerFloat.style.right = '0';
				}
			}
		}

		iconFilterFloat.addEventListener('click', handleIconClick);
		window.addEventListener('resize', handleResize);

		// Initial check
		handleResize();



	});

	document.addEventListener('DOMContentLoaded', function () {
		const rangeInput = document.getElementById('rangeID');
		const rangeLabel = document.querySelector('label[for="rangeID"]');

		if (!rangeInput || !rangeLabel) {
			return;
		}

		function updateLabel() {
			rangeLabel.textContent = `< ${rangeInput.value}km`;
		}

		rangeInput.addEventListener('input', updateLabel);

		// Initial update
		updateLabel();



	});

	document.addEventListener('DOMContentLoaded', function() {
		function getScrollbarWidth() {
			const container = document.createElement('div');
			container.style.visibility = 'hidden';
			container.style.overflow = 'scroll';
			container.style.msOverflowStyle = 'scrollbar';
			document.body.appendChild(container);

			const inner = document.createElement('div');
			container.appendChild(inner);

			const scrollbarWidth = container.offsetWidth - inner.offsetWidth;

			document.body.removeChild(container);

			return scrollbarWidth;
		}

		const scrollbarWidth = getScrollbarWidth();
		const headerContent = document.querySelector('#header');

		const observer = new MutationObserver(mutations => {
			mutations.forEach(mutation => {
				if (mutation.attributeName === 'class') {
					if (document.body.classList.contains('modal-open')) {
						document.body.style.paddingRight = `${scrollbarWidth}px`;
						if (headerContent) {
							headerContent.style.paddingRight = `${scrollbarWidth}px`;
						}
					} else {
						document.body.style.paddingRight = '';
						if (headerContent) {
							headerContent.style.paddingRight = '';
						}
					}
				}
			});
		});

		observer.observe(document.body, {
			attributes: true
		});
	});



})(jQuery);
